
import { Options, Vue } from "vue-class-component";
import { ref } from "vue";
import * as echarts from "echarts";

import {
  dispatchObjectMemoryDate,
  dispatchObjectMemoryVersion,
  dispatchObjectMemoryDevice,
  dispatchObjectMemoryScene,
  dispatchObjectMemoryList,
  dispatchObjectMemoryListData,
  dispatchObjectModuleList,
  dispatchObjectModuleTrend,
  dispatchObjectMemoryType,
  dispatchObjectMemoryDateVersion,
  dispatchObjectMemoryReport,
  dispatchObjectMemoryDateLevel,
  dispatchObjectMemoryTrend,
  dispatchObjectMemorySceneSecond,
  dispatchObjectMemorymoduleAll,
  dispatchObjectModuleListSecond,
  dispatchObjectModuleSubTrend,
  dispatchObjectFuncAll,
  dispatchObjectFunctionTrend,
  dispatchObjectFunctionTrendDraw,
  dispatchObjectMemoryDeviceSecond,
  dispatchPerfettoSettings,
  dispatchPerfettoSettingsEdit,
  dispatchDeleteObject,
  dispatchDeleteRowObject,
  dispatchPerfettoObjectExport,
  dispatchObjectMemoryStack,
  dispatchObjectMemoryStackOld,
  dispatchObjectMemoryDateVersionNew,
  dispatchObjectMemorySubStack,
  dispatchObjectMemorySubStackOld,
  dispatchObjectFunctionTrendAll,
  dispatchObjectMemoryAllStack,
  dispatchObjectMemoryAllStackOld,
  dispatchObjectModuleListAppoint,
  dispatchObjectModuleListAppointOld,
  dispatchObjectFunctionAppoint,
  dispatchObjectFunctionAppointOld,
  dispatchObjectMemoryAppointStack,
  dispatchObjectMemoryAppointOldLeftStack,
  dispatchObjectMemoryAppointOldRightStack,
  dispatchObjectFunctionId,
  dispatchObjectModuleListId,
  dispatchObjectMemoryDownLoad,
  dispatchObjectMemoryFileName,
  dispatchObjectMemoryDateVersionDevice,
} from "@/store/performance/actions";
import {
  readGetObjectDate,
  readGetObjectScene,
  readGetObjectDevice,
  readGetObjectVersion,
  readGetObjectList,
  readGetObjectListData,
  readGetObjectModuleList,
  readGetObjectModuleListSecond,
  readGetObjectModuleTrend,
  readGetObjectType,
  readGetObjectDateVersion,
  readGetObjectDateVersionNew,
  readGetObjectMemoryReport,
  readGetObjectMemoryLevel,
  readGetObjectMemoryTrend,
  readGetObjectMemorySecond,
  readGetObjectModuleAll,
  readGetObjectModuleSubTrend,
  readGetPerfettoFuncAll,
  readGetObjectFunctionTrend,
  readGetObjectFunctionTrendDraw,
  readGetObjectDeviceSecond,
  readGetPerfettoSettings,
  readGetObjectStack,
  readGetObjectStackOld,
  readGetObjectSubStack,
  readGetObjectSubStackOld,
  readGetObjectFunctionList,
  readGetObjectAllStack,
  readGetObjectAllStackOld,
  readGetObjectFunctionAppoint,
  readGetObjectFunctionAppointOld,
  readGetObjectModuleListAppoint,
  readGetObjectModuleListAppointOld,
  readGetObjectAppoinStack,
  readGetObjectAppoinOldLeftStack,
  readGetObjectAppoinOldRightStack,
  readGetObjectModuleId,
  readGetObjectFunctionId,
  readGetObjectDateVersionDevice,
} from "@/store/performance/getters"; //引入仓库接口
import { dispatchCreateSceneScriptTop } from "@/store/task/actions";
import { store } from "@/store";
import Quill from "quill";
import { readUserProfile } from "@/store/main/getters";
import { flamegraph } from "d3-flame-graph";
import * as d3 from "d3";
import { ElMessage } from "element-plus";
import {
  compare,
  dateConversion,
  getLocalProject,
  special_projects,
  unique_json,
} from "@/utils";

import { readUploadTopPerformanceLoad } from "@/store/performance/getters";
// @Options({
//   components: {},
// })
export default class OperationalData extends Vue {
  public localProject = 34;
  public current_page = 1;
  public record = 20;
  public pick = [];
  public get sizeOptions() {
    let list = [10, 20, 30, "all"];

    return list;
  }
  public get moudle_id_list() {
    return readGetObjectModuleId(store).options;
  }
  public get function_id_list() {
    return readGetObjectFunctionId(store).options;
  }
  public get moudle_list_appoint() {
    return readGetObjectModuleListAppoint(store).options;
  }
  public get moudle_list_appoint_old() {
    return readGetObjectModuleListAppointOld(store).options;
  }
  public get function_list_appoint() {
    return readGetObjectFunctionAppoint(store).options;
  }
  public get function_list_appoint_old() {
    return readGetObjectFunctionAppointOld(store).options;
  }
  public get ObjectStackData() {
    return readGetObjectStack(store);
  }
  public get ObjectStackSubData() {
    return readGetObjectSubStack(store);
  }
  public get ObjectStackSubDataOld() {
    return readGetObjectSubStackOld(store);
  }
  public get ObjectStackDataOld() {
    return readGetObjectStackOld(store);
  }
  public get ObjectStackAllDataOld() {
    return readGetObjectAllStackOld(store);
  }
  public get ObjectStackAllData() {
    return readGetObjectAllStack(store);
  }
  public get ObjectStackAppoinData() {
    return readGetObjectAppoinStack(store);
  }
  public get ObjectStackAppoinOldLeftData() {
    return readGetObjectAppoinOldLeftStack(store);
  }
  public get ObjectStackAppoinOldRightData() {
    return readGetObjectAppoinOldRightStack(store);
  }
  public renderFlame(selector, data) {
    let flame: any = flamegraph();
    function getAllValues(node) {
      const values = [node.value];
      if (Array.isArray(node.children)) {
        node.children.forEach((child) => {
          values.push(...getAllValues(child));
        });
      }
      return values;
    }

    // 获取火焰图数据中的最大值
    const allValues = getAllValues(data);
    const maxDataValue = d3.max(allValues);
    const container = document.getElementById("stack");
    const containerWidth = container?.clientWidth;
    // 创建颜色映射器
    const colorMapper = d3
      .scaleLinear()
      .domain([0, maxDataValue * 0.5, maxDataValue])
      .range(["#B6EBCF  ", "#FEBEBE", "#DAC4FF"]);
    flame
      .width(containerWidth)
      .label((d) => this.labelTime(d, data))
      // .tooltip({ show: this.customTooltip })
      .transitionDuration(1000)
      // .color((d) => colorMapper(d.data.value)) // 使用自定义颜色映射器
      .setColorMapper((d, originalColor) =>
        this.labelWallTime(d, originalColor, colorMapper)
      ); // 传递 colorMapper 参数
    // .onHover((node, el) => this.handleHover(node, el)); // 添加 onHover 方法

    //  ;

    // flame.onHover((node) => {
    //   this.func_name = node.data.name;
    //   this.func_rate = node.data.rate + "%";
    // });

    d3.select(selector).datum(data).call(flame);
    // d3.select(selector).style("background-color", "#333");
  }
  public renderFlameAppoint(selector, data) {
    let flame: any = flamegraph();
    function getAllValues(node) {
      const values = [node.value];
      if (Array.isArray(node.children)) {
        node.children.forEach((child) => {
          values.push(...getAllValues(child));
        });
      }
      return values;
    }

    // 获取火焰图数据中的最大值
    const allValues = getAllValues(data);
    const maxDataValue = d3.max(allValues);
    const container = document.getElementById("stackAppointStack");
    const containerWidth = container?.clientWidth;
    // 创建颜色映射器
    const colorMapper = d3
      .scaleLinear()
      .domain([0, maxDataValue * 0.5, maxDataValue])
      .range(["#B6EBCF  ", "#FEBEBE", "#DAC4FF"]);
    flame
      .width(containerWidth)
      .label((d) => this.labelTime(d, data))
      // .tooltip({ show: this.customTooltip })
      .transitionDuration(1000)
      // .color((d) => colorMapper(d.data.value)) // 使用自定义颜色映射器
      .setColorMapper((d, originalColor) =>
        this.labelWallTimeAppoint(d, originalColor, colorMapper)
      ); // 传递 colorMapper 参数
    // .onHover((node, el) => this.handleHover(node, el)); // 添加 onHover 方法

    //  ;

    // flame.onHover((node) => {
    //   this.func_name = node.data.name;
    //   this.func_rate = node.data.rate + "%";
    // });

    d3.select(selector).datum(data).call(flame);
    // d3.select(selector).style("background-color", "#333");
  }
  public renderFlameAppointleft(selector, data) {
    let flame: any = flamegraph();
    function getAllValues(node) {
      const values = [node.value];
      if (Array.isArray(node.children)) {
        node.children.forEach((child) => {
          values.push(...getAllValues(child));
        });
      }
      return values;
    }

    // 获取火焰图数据中的最大值
    const allValues = getAllValues(data);
    const maxDataValue = d3.max(allValues);
    const container = document.getElementById("stackAppointStackLeft");
    const containerWidth = container?.clientWidth;
    // 创建颜色映射器
    const colorMapper = d3
      .scaleLinear()
      .domain([0, maxDataValue * 0.5, maxDataValue])
      .range(["#B6EBCF  ", "#FEBEBE", "#DAC4FF"]);
    flame
      .width(containerWidth)
      .label((d) => this.labelTime(d, data))
      // .tooltip({ show: this.customTooltip })
      .transitionDuration(1000)
      // .color((d) => colorMapper(d.data.value)) // 使用自定义颜色映射器
      .setColorMapper((d, originalColor) =>
        this.labelWallTimeAppointOld(d, originalColor, colorMapper)
      ); // 传递 colorMapper 参数
    // .onHover((node, el) => this.handleHover(node, el)); // 添加 onHover 方法

    //  ;

    // flame.onHover((node) => {
    //   this.func_name = node.data.name;
    //   this.func_rate = node.data.rate + "%";
    // });

    d3.select(selector).datum(data).call(flame);
    // d3.select(selector).style("background-color", "#333");
  }
  public renderFlameAppointRight(selector, data) {
    let flame: any = flamegraph();
    function getAllValues(node) {
      const values = [node.value];
      if (Array.isArray(node.children)) {
        node.children.forEach((child) => {
          values.push(...getAllValues(child));
        });
      }
      return values;
    }

    // 获取火焰图数据中的最大值
    const allValues = getAllValues(data);
    const maxDataValue = d3.max(allValues);
    const container = document.getElementById("stackAppointStackRight");
    const containerWidth = container?.clientWidth;
    // 创建颜色映射器
    const colorMapper = d3
      .scaleLinear()
      .domain([0, maxDataValue * 0.5, maxDataValue])
      .range(["#B6EBCF  ", "#FEBEBE", "#DAC4FF"]);
    flame
      .width(containerWidth)
      .label((d) => this.labelTime(d, data))
      // .tooltip({ show: this.customTooltip })
      .transitionDuration(1000)
      // .color((d) => colorMapper(d.data.value)) // 使用自定义颜色映射器
      .setColorMapper((d, originalColor) =>
        this.labelWallTimeAppointOld(d, originalColor, colorMapper)
      ); // 传递 colorMapper 参数
    // .onHover((node, el) => this.handleHover(node, el)); // 添加 onHover 方法

    //  ;

    // flame.onHover((node) => {
    //   this.func_name = node.data.name;
    //   this.func_rate = node.data.rate + "%";
    // });

    d3.select(selector).datum(data).call(flame);
    // d3.select(selector).style("background-color", "#333");
  }
  public stack_width_sub = 47.5;
  public stack_width_sub_old = 47.5;
  public renderFlameSub(selector, data) {
    let flame: any = flamegraph();
    function getAllValues(node) {
      const values = [node.value];
      if (Array.isArray(node.children)) {
        node.children.forEach((child) => {
          values.push(...getAllValues(child));
        });
      }
      return values;
    }

    // 获取火焰图数据中的最大值
    const allValues = getAllValues(data);
    const maxDataValue = d3.max(allValues);
    const container = document.getElementById("stackSub");
    const containerWidth = container?.clientWidth;
    // 创建颜色映射器
    const colorMapper = d3
      .scaleLinear()
      .domain([0, maxDataValue * 0.5, maxDataValue])
      .range(["#B6EBCF  ", "#FEBEBE", "#DAC4FF"]);
    flame
      .width(containerWidth)
      .label((d) => this.labelTime(d, data))
      // .tooltip({ show: this.customTooltip })
      .transitionDuration(1000)
      // .color((d) => colorMapper(d.data.value)) // 使用自定义颜色映射器
      .setColorMapper((d, originalColor) =>
        this.labelWallTimeSub(d, originalColor, colorMapper)
      ); // 传递 colorMapper 参数
    // .onHover((node, el) => this.handleHover(node, el)); // 添加 onHover 方法

    //  ;

    // flame.onHover((node) => {
    //   this.func_name = node.data.name;
    //   this.func_rate = node.data.rate + "%";
    // });

    d3.select(selector).datum(data).call(flame);
    // d3.select(selector).style("background-color", "#333");
  }
  public async handleDeleteScene(data) {
    this.test_data_loading = true;
    await dispatchDeleteRowObject(store, {
      project: this.localProject,
      id: data.id,
    });
    await dispatchObjectMemoryListData(store, {
      project: this.localProject,
      date_list: this.object_options_model.date.join(","),
    });
    this.object_list_data();
    this.test_data_loading = false;
    //   await dispatchObjectMemoryList(store, {
    //   project: this.localProject,
    //   date: this.object_options_model.date.join(","),
    //   version: this.object_options_model.version.join(","),
    //   device_id: this.object_options_model.device.join(","),
    //   scene_name: this.object_options_model.scene.join(","),
    //      page:this.current_page,
    //   size:this.record
    // });
  }
  public renderFlameAll(selector, data) {
    let flame: any = flamegraph();
    function getAllValues(node) {
      const values = [node.value];
      if (Array.isArray(node.children)) {
        node.children.forEach((child) => {
          values.push(...getAllValues(child));
        });
      }
      return values;
    }

    // 获取火焰图数据中的最大值
    const allValues = getAllValues(data);
    const maxDataValue = d3.max(allValues);
    const container = document.getElementById("stackAllStack");
    const containerWidth = container?.clientWidth;
    // 创建颜色映射器
    const colorMapper = d3
      .scaleLinear()
      .domain([0, maxDataValue * 0.5, maxDataValue])
      .range(["#B6EBCF  ", "#FEBEBE", "#DAC4FF"]);
    flame
      .width(containerWidth)
      .label((d) => this.labelTime(d, data))
      // .tooltip({ show: this.customTooltip })
      .transitionDuration(1000)
      // .color((d) => colorMapper(d.data.value)) // 使用自定义颜色映射器
      .setColorMapper((d, originalColor) =>
        this.labelWallTimeAll(d, originalColor, colorMapper)
      ); // 传递 colorMapper 参数
    // .onHover((node, el) => this.handleHover(node, el)); // 添加 onHover 方法

    //  ;

    // flame.onHover((node) => {
    //   this.func_name = node.data.name;
    //   this.func_rate = node.data.rate + "%";
    // });

    d3.select(selector).datum(data).call(flame);
    // d3.select(selector).style("background-color", "#333");
  }
  public renderFlameSubOld(selector, data) {
    let flame: any = flamegraph();
    function getAllValues(node) {
      const values = [node.value];
      if (Array.isArray(node.children)) {
        node.children.forEach((child) => {
          values.push(...getAllValues(child));
        });
      }
      return values;
    }

    // 获取火焰图数据中的最大值
    const allValues = getAllValues(data);
    const maxDataValue = d3.max(allValues);
    const container = document.getElementById("stackSubOld");
    const containerWidth = container?.clientWidth;
    // 创建颜色映射器
    const colorMapper = d3
      .scaleLinear()
      .domain([0, maxDataValue * 0.5, maxDataValue])
      .range(["#B6EBCF  ", "#FEBEBE", "#DAC4FF"]);
    flame
      .width(containerWidth)
      .label((d) => this.labelTime(d, data))
      // .tooltip({ show: this.customTooltip })
      .transitionDuration(1000)
      // .color((d) => colorMapper(d.data.value)) // 使用自定义颜色映射器
      .setColorMapper((d, originalColor) =>
        this.labelWallTimeSub(d, originalColor, colorMapper)
      ); // 传递 colorMapper 参数
    // .onHover((node, el) => this.handleHover(node, el)); // 添加 onHover 方法

    //  ;

    // flame.onHover((node) => {
    //   this.func_name = node.data.name;
    //   this.func_rate = node.data.rate + "%";
    // });

    d3.select(selector).datum(data).call(flame);
    // d3.select(selector).style("background-color", "#333");
  }
  public labelWallTime = (d, originalColor, colorMapper) => {
    // 使用 colorMapper 计算颜色
    const color = colorMapper(d.data.value);

    // 如果没有输入，直接返回计算出的颜色
    if (this.stack.func.length == 0) {
      return color;
    } else {
      // 如果输入存在，根据输入内容判断是否需要修改颜色
      //     if(this.stack.module){
      //         let list=this.stack.module.split(';')
      //         console.log(list)
      //         // 变为数组 主要目的是内置方法直接字符串indexof!=-1 会bug 底层是0判断 但是判断不全
      //        const hasMatchingKeyword = list.some((v) => {
      //   return d.data.functionName.toUpperCase().indexOf(v.toUpperCase()) !== -1;
      // });

      // // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
      // return hasMatchingKeyword ? "#f00" : color;

      //     }
      if (this.stack.func) {
        const hasMatchingKeyword = this.stack.func.some((v) => {
          return d.data.name.toUpperCase().indexOf(v.toUpperCase()) !== -1;
        });

        // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
        return hasMatchingKeyword ? "#f00" : color;
      }
    }
  };
  public labelWallTimeSub = (d, originalColor, colorMapper) => {
    // 使用 colorMapper 计算颜色
    const color = colorMapper(d.data.value);
    return color;
    // 如果没有输入，直接返回计算出的颜色
    //   if (this.sub_moudel.module.length==0) {
    //     return color;
    //   }
    //   else {
    //     // 如果输入存在，根据输入内容判断是否需要修改颜色
    // //     if(this.stack.module){
    // //         let list=this.stack.module.split(';')
    // //         console.log(list)
    // //         // 变为数组 主要目的是内置方法直接字符串indexof!=-1 会bug 底层是0判断 但是判断不全
    // //        const hasMatchingKeyword = list.some((v) => {
    // //   return d.data.functionName.toUpperCase().indexOf(v.toUpperCase()) !== -1;
    // // });

    // // // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
    // // return hasMatchingKeyword ? "#f00" : color;

    // //     }

    //        const hasMatchingKeyword = this.sub_moudel.module.some((v) => {
    //   return d.data.name.toUpperCase().indexOf(v.toUpperCase()) !== -1;
    // });

    // // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
    // return hasMatchingKeyword ? "#f00" : color;

    //   }
  };
  public labelWallTimeAll = (d, originalColor, colorMapper) => {
    // 使用 colorMapper 计算颜色
    const color = colorMapper(d.data.value);

    // 如果没有输入，直接返回计算出的颜色
    if (this.all_data.func.length == 0) {
      return color;
    } else {
      // 如果输入存在，根据输入内容判断是否需要修改颜色
      //     if(this.stack.module){
      //         let list=this.stack.module.split(';')
      //         console.log(list)
      //         // 变为数组 主要目的是内置方法直接字符串indexof!=-1 会bug 底层是0判断 但是判断不全
      //        const hasMatchingKeyword = list.some((v) => {
      //   return d.data.functionName.toUpperCase().indexOf(v.toUpperCase()) !== -1;
      // });

      // // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
      // return hasMatchingKeyword ? "#f00" : color;

      //     }

      const hasMatchingKeyword = this.all_data.func.some((v) => {
        return d.data.name.toUpperCase().indexOf(v.toUpperCase()) !== -1;
      });

      // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
      return hasMatchingKeyword ? "#f00" : color;
    }
  };
  // public async functionBtn() {
  //   let data = readGetPerfettoFuncAll(store);
  //   await dispatchObjectMemoryAllStack(store, {
  //     project: this.localProject,
  //     id: data.id,
  //     module: "",
  //     func: this.all_data.func.length > 0 ? this.all_data.func.join(";") : "",
  //     size: "",
  //   });
  //   this.renderFlameAll("#stackAllStack", this.ObjectStackAllData);
  //   await dispatchObjectMemoryAllStackOld(store, {
  //     project: this.localProject,
  //     id: data.old_id,
  //     module: "",
  //     func: this.all_data.func.length > 0 ? this.all_data.func.join(";") : "",
  //     size: "",
  //   });
  //   this.renderFlameAll("#stackAllStackOld", this.ObjectStackAllDataOld);
  // }
  public labelWallTimeAppoint = (d, originalColor, colorMapper) => {
    // 使用 colorMapper 计算颜色
    const color = colorMapper(d.data.value);

    // 如果没有输入，直接返回计算出的颜色
    if (this.appoint.func.length == 0) {
      return color;
    } else {
      // 如果输入存在，根据输入内容判断是否需要修改颜色
      //     if(this.stack.module){
      //         let list=this.stack.module.split(';')
      //         console.log(list)
      //         // 变为数组 主要目的是内置方法直接字符串indexof!=-1 会bug 底层是0判断 但是判断不全
      //        const hasMatchingKeyword = list.some((v) => {
      //   return d.data.functionName.toUpperCase().indexOf(v.toUpperCase()) !== -1;
      // });

      // // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
      // return hasMatchingKeyword ? "#f00" : color;

      //     }

      const hasMatchingKeyword = this.appoint.func.some((v) => {
        return d.data.name.toUpperCase().indexOf(v.toUpperCase()) !== -1;
      });

      // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
      return hasMatchingKeyword ? "#f00" : color;
    }
  };
  public selectTableChange(type) {
    this.current_page = type ? 1 : this.current_page;
    this.confirm();
  }
  public labelWallTimeAppointOld = (d, originalColor, colorMapper) => {
    // 使用 colorMapper 计算颜色
    const color = colorMapper(d.data.value);

    // 如果没有输入，直接返回计算出的颜色
    if (this.appointOld.func.length == 0) {
      return color;
    } else {
      // 如果输入存在，根据输入内容判断是否需要修改颜色
      //     if(this.stack.module){
      //         let list=this.stack.module.split(';')
      //         console.log(list)
      //         // 变为数组 主要目的是内置方法直接字符串indexof!=-1 会bug 底层是0判断 但是判断不全
      //        const hasMatchingKeyword = list.some((v) => {
      //   return d.data.functionName.toUpperCase().indexOf(v.toUpperCase()) !== -1;
      // });

      // // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
      // return hasMatchingKeyword ? "#f00" : color;

      //     }

      const hasMatchingKeyword = this.appointOld.func.some((v) => {
        return d.data.name.toUpperCase().indexOf(v.toUpperCase()) !== -1;
      });

      // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
      return hasMatchingKeyword ? "#f00" : color;
    }
  };
  public labelTime = (d, data) => {
    //  "(" +
    //   (d.parent == null
    //     ? "100%"
    //     : ((d.value / (data as any).value) * 100).toFixed(2) +
    //       "%") +

    //   ")"
    // return `<div><div style="font-size:14px">${d.data.name}</div><div>${d.data.value}</div><div>soName:${d.data.soName}</div></div>`
    return (
      "allocSize:" + this.getNum(d.data.value) + "\nfunction:" + d.data.name
    );
  };
  public getNum(num) {
    if (num >= 1024 * 1024) {
      return (num / 1024 / 1024).toFixed(2) + "MB";
    } else if (num >= 1024 && num < 1024 * 1024) {
      return (num / 1024).toFixed(2) + "KB";
    } else if (num < 1024) {
      return num.toFixed(2) + "B";
    }
  }
  public async flame_btn() {
    this.isInteger = Number.isInteger(Number(this.stack.size));
    if (this.isInteger == false) {
      ElMessage.error("size请输入整数");

      return;
    }
    this.stack_loading = true;
    await dispatchObjectMemoryStack(store, {
      project: this.localProject,
      id: this.stack_id,
      module: this.stack.module.join(";"),
      func: this.stack.func.join(";"),
      size: this.stack.size,
    });
    this.$nextTick(() => {
      this.renderFlame("#stack", this.ObjectStackData);
    });
    if (this.old_show) {
      await dispatchObjectMemoryStackOld(store, {
        project: this.localProject,
        id: this.stack_old_id,
        module: this.stack.module.join(";"),
        func: this.stack.func.join(";"),
        size: this.stack.size,
      });
      this.$nextTick(() => {
        this.renderFlame("#stackOld", this.ObjectStackDataOld);
      });
    }
    this.stack_loading = false;
  }
  public old_show = false;
  public sub_old_show = true;
  public stack_id = "";

  public stack_old_id = "";
  public stack_moudel = [];
  public stack_id_list = [];
  public isInteger = true;
  public appoint: any = {
    size: "",
    moudel: [],
    func: [],
    level: "",
    scene: "",
  };
  public appointOld: any = {
    size: "",
    moudel: [],
    func: [],
    level: "",
    scene: "",
    old_name: "",
  };
  public async stackBtn(id, module, type, new_id?) {
    this.stack_show = true;
    this.stack_loading = true;
    this.stack.module = module == "Sum" ? [] : [module];

    this.stack.size = "";
    this.stack.func = [];
    await dispatchObjectFunctionId(store, {
      project: this.localProject,
      id: id,
    });
    await dispatchObjectModuleListId(store, {
      project: this.localProject,
      id: id,
    });
    if (type == "new") {
      this.stack_id = id;
      this.stack_width = 100;
      this.stack_old_width = 0;
      await dispatchObjectMemoryStack(store, {
        project: this.localProject,
        id: id,
        module: module == "Sum" ? "" : module,
        func: "",
        size: "",
      });
      this.$nextTick(() => {
        this.renderFlame("#stack", this.ObjectStackData);
      });
      if (this.stack_moudel.length == 0 && this.stack_id_list.length == 0) {
        this.stack_id_list.push(id);
        this.stack_moudel.push(module);
      } else {
        if (this.stack_moudel[this.stack_moudel.length - 1] != module) {
          this.stack_moudel.push(module);
        }
        if (this.stack_id_list[this.stack_id_list.length - 1] != id) {
          this.stack_id_list.push(id);
        }
      }
      this.old_show = false;
    } else {
      this.old_show = true;
      this.stack_width = 47.5;
      this.stack_old_width = 47.5;
      this.stack_title = type === "base" ? "基线版本" : "对比版本";
      this.stack_id = new_id;
      this.stack_old_id = id;

      if (this.stack_moudel.length == 0 && this.stack_id_list.length == 0) {
        this.stack_id_list.push(new_id);
        this.stack_moudel.push(module);
        await dispatchObjectMemoryStack(store, {
          project: this.localProject,
          id: new_id,
          module: module == "Sum" ? "" : module,
          func: "",
          size: "",
        });
      } else {
        console.log(this.stack_id_list);
        if (
          this.stack_moudel[this.stack_moudel.length - 1] != module ||
          this.stack_id_list[this.stack_id_list.length - 1] != new_id
        ) {
          if (this.stack_id_list[this.stack_id_list.length - 1] != new_id) {
            this.stack_id_list.push(new_id);
          }
          if (this.stack_moudel[this.stack_moudel.length - 1] != module) {
            this.stack_moudel.push(module);
          }
          await dispatchObjectMemoryStack(store, {
            project: this.localProject,
            id: new_id,
            module: module == "Sum" ? "" : module,
            func: "",
            size: "",
          });
        }
      }
      this.$nextTick(() => {
        this.renderFlame("#stack", this.ObjectStackData);
      });

      await dispatchObjectMemoryStackOld(store, {
        project: this.localProject,
        id: id,
        module: module == "Sum" ? "" : module,
        func: "",
        size: "",
      });
      this.$nextTick(() => {
        this.renderFlame("#stackOld", this.ObjectStackDataOld);
      });
    }
    this.stack_loading = false;
  }
  public configShow = false;
  public configShow_old = false;
  public function_memory = {
    level: "",
    scene: "",
    function: [],
  };
  public download(data, module, type?) {
    dispatchObjectMemoryFileName(store, {
      project: this.localProject,
      id: data.id,
    }).then((res) => {
      dispatchObjectMemoryDownLoad(store, {
        project: this.localProject,
        id: data.id,
        old_id: type ? (type == "last" ? data.old_id : data.base_id) : "",
        func: "",
        module: module,
      }).then((htmlContent: any) => {
        console.log(htmlContent);
        // 创建一个 Blob 对象来存储 HTML 内容
        const blob = new Blob([htmlContent], { type: "text/html" });

        // 创建一个指向 Blob 对象的 URL
        const url = URL.createObjectURL(blob);

        // 创建一个临时的 <a> 标签
        const link = document.createElement("a");
        link.href = url; // 设置链接为 Blob URL
        link.download = `${res.filename}.html`; // 设置下载文件的名称
        link.style.display = "none"; // 隐藏 <a> 标签

        // 将 <a> 标签添加到 DOM 中
        document.body.appendChild(link);

        // 触发点击事件以开始下载
        link.click();

        // 从 DOM 中移除 <a> 标签
        document.body.removeChild(link);

        // 释放 Blob URL
        URL.revokeObjectURL(url);
      });
    });
  }
  public downloadCsv() {
    this.function_table_loading = true;
    let b = (this as any).$message({
      //Message 消息提示
      message: "导出中,请耐心等待....",
      showClose: true,
      duration: 0,
      customClass: "centered-message", // 添加自定义类名
    });

    const response_data = dispatchPerfettoObjectExport(store, {
      project: this.localProject,
      level: this.all_data.level,
      device_id: Number(this.overView.device),
      date:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].version
          : "",
      scene_name: this.all_data.scene,
      top: this.all_data.top,
      search: this.all_data.serch,
      old_date:
        this.dateVersion_option.filter((v) => v.name == this.all_data.old_name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.all_data.old_name
            )[0].date
          : "",
      old_version:
        this.dateVersion_option.filter((v) => v.name == this.all_data.old_name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.all_data.old_name
            )[0].version
          : "",

      order_by: this.order_by,
      reverse: this.reserver,
      report_type: this.overView.type,
    });
    // this.nativeTableAll = this.nativeAllData.slice(
    //   (this.page - 1) * this.size,
    //   this.page * this.size
    // );
    response_data.then((value) => {
      // console.log(value);
      var elink = document.createElement("a");
      elink.download = "全量内存数据查看" + ".xls";
      elink.style.display = "none";
      var blob = new Blob([value], { type: "application/vnd.ms-excel" });

      elink.href = URL.createObjectURL(blob);
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
      b.close();
      this.function_table_loading = false;
    });
  }
  public base_id = "";
  public old_id = "";
  public serch_stack_loading = false;
  public async function_api(type) {
    if (type) {
      await dispatchObjectFunctionTrend(store, {
        project: this.localProject,
        report_type: this.overView.type,
        level: this.function_memory.level,
        start: "",
        end: "",
        scene_name: this.function_memory.scene,
        device_id: this.overView.device,
        date:
          this.dateVersion_option.filter((v) => v.name == this.overView.name)
            .length > 0
            ? this.dateVersion_option.filter(
                (v) => v.name == this.overView.name
              )[0].date
            : "",
        version:
          this.dateVersion_option.filter((v) => v.name == this.overView.name)
            .length > 0
            ? this.dateVersion_option.filter(
                (v) => v.name == this.overView.name
              )[0].version
            : "",
      });
      this.function_memory.function = this.function_list.filter(
        (v, index) => index <= 4
      );
    }
    await dispatchObjectFunctionTrendDraw(store, {
      project: this.localProject,
      report_type: this.overView.type,
      level: this.function_memory.level,
      start: "",
      end: "",
      scene_name: this.function_memory.scene,
      func_list: this.function_memory.function.join(";"),
    });
    this.drawFunctionTrend();
    this.function_loading = false;
  }
  public get function_list() {
    return readGetObjectFunctionTrend(store).options;
  }
  public get function_all_list() {
    return readGetObjectFunctionList(store).options;
  }
  public get memory_all_data_list() {
    return readGetPerfettoFuncAll(store)?.list;
  }
  public get sub_moudel_trend_data() {
    return readGetObjectModuleSubTrend(store);
  }
  public get function_trend_data() {
    return readGetObjectFunctionTrendDraw(store);
  }
  public get sub_moudel_data() {
    let list = readGetObjectModuleAll(store);
    list.list?.forEach((v) => {
      v.level = list.level;
      v.scene = list.scene_name;
    });
    return list;
  }
  public trend = {
    device: [],
    scene: [],
    moudle: [],
  };
  public sub_moudel = {
    level: "",
    scene: "",
    old_name: "",
    serch: "",
    top: 20,
    page: 1,
    size: 10,
    module: [],
  };
  public all_data = {
    level: "",
    scene: "",
    old_name: "",
    serch: "",
    top: 20,
    page: 1,
    size: 10,
    func: [],
  };
  public sub_moudel_trend = {
    level: "",
    scene: "",
    moudel: [],
  };
  public old_record_id_created() {
    let num = 0;
    if (this.dateVersion_option.length > 1) {
      if (
        this.dateVersion_option[this.dateVersion_option.length - 1].name ==
        this.overView.name
      ) {
        this.dateVersion_option.forEach((v, index) => {
          if (v.name == this.overView.name) {
            num = index;
          }
        });
        this.sub_moudel.old_name = this.dateVersion_option[num - 1].name;
        this.appointOld.old_name = this.dateVersion_option[num - 1].name;
        this.all_data.old_name = this.dateVersion_option[num - 1].name;
      } else {
        this.dateVersion_option.forEach((v, index) => {
          if (v.name == this.overView.name) {
            num = index;
          }
        });
        this.sub_moudel.old_name = this.dateVersion_option[num + 1].name;
        this.appointOld.old_name = this.dateVersion_option[num + 1].name;
        this.all_data.old_name = this.dateVersion_option[num + 1].name;
      }
      // this.perfDateOptions.forEach((v,index)=>{
      //   if(v.task_record_id==this.task_id){
      //     num=index
      //   }
      // })
      // if(num==(this.perfDateOptions.length-1)){

      // }
    } else {
      this.sub_moudel.old_name = this.dateVersion_option[0].name;
      this.appointOld.old_name = this.dateVersion_option[0].name;
      this.all_data.old_name = this.dateVersion_option[0].name;
    }
  }
  public get memory_all_data() {
    return readGetObjectMemoryTrend(store);
  }
  public get scene_second_options() {
    return readGetObjectMemorySecond(store).options;
  }

  public async confirm_memoryAll() {
    await dispatchObjectMemoryTrend(store, {
      project: this.localProject,
      report_type: this.overView.type,
      level: this.overView.level,
      start:
        this.overView.pick.length > 0
          ? dateConversion(this.overView.pick[0])
          : "",
      end:
        this.overView.pick.length > 0
          ? dateConversion(this.overView.pick[1])
          : "",
    });
    this.drawMemoryAllTrend();
    this.all_memory_loading = false;
  }
  public get name_img() {
    return readUserProfile(store).username;
  }
  public mergeCells({ row, column, rowIndex, columnIndex }) {
    if (columnIndex === 0) {
      const rowCount = this.object_list_table.filter(
        (item) => item.model === row.model
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.object_list_table.findIndex(
            (item) => item.model === row.model
          ) === rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
  }
  public mergeCells1({ row, column, rowIndex, columnIndex }) {
    if (columnIndex === 0) {
      const rowCount = this.perfReport_top.filter(
        (item) => item.level === row.level
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.perfReport_top.findIndex((item) => item.level === row.level) ===
          rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
    if (columnIndex === 1) {
      const rowCount = this.perfReport_top.filter(
        (item) => item.version === row.version
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.perfReport_top.findIndex(
            (item) => item.version === row.version
          ) === rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
    if (columnIndex === 2) {
      const rowCount = this.perfReport_top.filter(
        (item) => item.scene === row.scene
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.perfReport_top.findIndex((item) => item.scene === row.scene) ===
          rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
    if (columnIndex === 3) {
      const rowCount = this.perfReport_top.filter(
        (item) =>
          item.memory_diff === row.memory_diff && item.diif_new === row.diif_new
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.perfReport_top.findIndex(
            (item) =>
              item.memory_diff === row.memory_diff &&
              item.diif_new === row.diif_new
          ) === rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
  }
  public async deviceChange() {
    await dispatchObjectMemoryDateVersionDevice(store, {
      project: this.localProject,
      device_id: this.device_id,
    });
    if (this.settings.object_memory_set) {
      if (this.settings.object_memory_set[this.device_id]) {
        this.base_id = this.settings.object_memory_set[this.device_id]
          ? this.settings.object_memory_set[this.device_id]
          : "";
      } else {
        this.base_id = "";
      }
    } else {
      this.base_id = "";
    }
  }
  public async deleteBtn() {
    await dispatchDeleteObject(store, {
      project: this.localProject,
      date:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].version
          : "",
      device_id: this.overView.device,
      report_type: this.overView.type,
    });
    // const endDate = new Date();
    // const startDate = new Date();
    this.all_data.top = 20;
    this.all_data.page = 1;
    this.all_data.size = 10;
    this.sub_moudel.top = 20;
    this.sub_moudel.page = 1;
    this.sub_moudel.size = 10;
    this.reserver = 1;
    this.order_by = "diff";
    // this.overView.pick = [startDate, endDate];
    this.all_data.serch = "";
    this.sub_moudel.serch = "";
    this.second_check = true;
    this.handleClick();
  }
  // public async risk_btn(func) {
  //   this.all_data.func = [func];
  //   let data = readGetPerfettoFuncAll(store);
  //   await dispatchObjectMemoryAllStack(store, {
  //     project: this.localProject,
  //     id: data.id,
  //     module: "",
  //     func: this.all_data.func.length > 0 ? this.all_data.func.join(";") : "",
  //     size: "",
  //   });
  //   this.renderFlameAll("#stackAllStack", this.ObjectStackAllData);
  //   await dispatchObjectMemoryAllStackOld(store, {
  //     project: this.localProject,
  //     id: data.old_id,
  //     module: "",
  //     func: this.all_data.func.length > 0 ? this.all_data.func.join(";") : "",
  //     size: "",
  //   });
  //   this.renderFlameAll("#stackAllStackOld", this.ObjectStackAllDataOld);
  // }
  public async viewOld(data) {
    this.activeName = "second";
    this.all_memory_loading = true;
    this.function_loading = true;
    this.sub_moudel_loading = true;
    this.sub_moudel_list_loading = true;
    this.function_table_loading = true;
    this.sub_moudel_list_loading = true;
    this.memory_report = true;
    await dispatchObjectMemoryType(store, {
      project: this.localProject,
    });
    this.overView.type = data.report_type;
    await dispatchObjectMemoryDateVersion(store, {
      project: this.localProject,
      report_type: this.overView.type,
    });
    this.overView.name = data.old_date + " " + data.old_version;
    this.old_record_id_created();
    await dispatchObjectMemoryDeviceSecond(store, {
      project: this.localProject,
      report_type: this.overView.type,
      date:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].version
          : "",
    });
    this.overView.device = data.device.id;
    this.confirm_second();
    await dispatchObjectMemoryDateLevel(store, {
      project: this.localProject,
      report_type: this.overView.type,
      date:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].version
          : "",
      device_id: this.overView.device,
    });
    this.overView.level = data.level;
    this.sub_moudel.level = data.level;
    this.all_data.level = data.level;
    this.sub_moudel_trend.level = data.level;
    this.function_memory.level = data.level;
    this.appoint.level = data.level;
    this.appointOld.level = data.level;
    this.confirm_memoryAll();
    await dispatchObjectMemorySceneSecond(store, {
      project: this.localProject,
      report_type: this.overView.type,
      date:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].version
          : "",
      device_id: this.overView.device,
    });
    this.sub_moudel.scene = data.scene_name;
    this.all_data.scene = data.scene_name;
    this.sub_moudel_trend.scene = data.scene_name;
    this.function_memory.scene = data.scene_name;
    this.appoint.scene = data.scene_name;
    this.appointOld.scene = data.scene_name;
    this.function_api(true);
    this.sub_moudel_change();

    this.sub_moudel_api(true);

    this.alldata_change();
    this.appoint_api();
    this.appoint_api_old();
    this.second_check = false;
  }
  public con_stack_loading = false;
  public async appoint_api() {
    dispatchObjectModuleListAppoint(store, {
      project: this.localProject,
      start: "",
      end: "",
      device_id: this.overView.device,
      scene_name: this.appoint.scene,
      level: this.appoint.level,
      report_type: this.overView.type,
    });
    await dispatchObjectFunctionAppoint(store, {
      project: this.localProject,
      report_type: this.overView.type,
      level: this.appoint.level,
      start: "",
      end: "",
      scene_name: this.appoint.scene,
      device_id: this.overView.device,
      date:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].version
          : "",
    });
    await dispatchObjectMemoryAppointStack(store, {
      project: this.localProject,

      module: this.appoint.moudel.join(";"),
      func: this.appoint.func.join(";"),
      size: this.appoint.size,
      date:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].version
          : "",
      device_id: Number(this.overView.device),
      report_type: this.overView.type,

      scene_name: this.appoint.scene,
      level: this.appoint.level,
    });
    this.$nextTick(() => {
      this.renderFlameAppoint("#stackAppointStack", this.ObjectStackAppoinData);
      this.serch_stack_loading = false;
    });
  }
  public async flame_btn_appoint() {
    this.isInteger = Number.isInteger(Number(this.appoint.size));
    if (this.isInteger == false) {
      ElMessage.error("size请输入整数");

      return;
    }
    this.serch_stack_loading = true;
    await dispatchObjectMemoryAppointStack(store, {
      project: this.localProject,

      module: this.appoint.moudel.join(";"),
      func: this.appoint.func.join(";"),
      size: this.appoint.size,
      date:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].version
          : "",
      device_id: Number(this.overView.device),
      report_type: this.overView.type,

      scene_name: this.appoint.scene,
      level: this.appoint.level,
    });
    this.$nextTick(() => {
      this.renderFlameAppoint("#stackAppointStack", this.ObjectStackAppoinData);
      this.serch_stack_loading = false;
    });
  }
  public async flame_btn_appoint_old() {
    this.isInteger = Number.isInteger(Number(this.appointOld.size));
    if (this.isInteger == false) {
      ElMessage.error("size请输入整数");

      return;
    }
    this.con_stack_loading = true;
    await dispatchObjectMemoryAppointOldLeftStack(store, {
      project: this.localProject,
      module: this.appointOld.moudel.join(";"),
      func: this.appointOld.func.join(";"),
      size: this.appointOld.size,
      date:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].version
          : "",
      device_id: Number(this.overView.device),
      report_type: this.overView.type,

      scene_name: this.appointOld.scene,
      level: this.appointOld.level,
    });
    this.$nextTick(() => {
      this.renderFlameAppointleft(
        "#stackAppointStackLeft",
        this.ObjectStackAppoinOldLeftData
      );
    });
    await dispatchObjectMemoryAppointOldRightStack(store, {
      project: this.localProject,
      module: this.appointOld.moudel.join(";"),
      func: this.appointOld.func.join(";"),
      size: this.appointOld.size,
      date:
        this.dateVersion_option.filter(
          (v) => v.name == this.appointOld.old_name
        ).length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.appointOld.old_name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter(
          (v) => v.name == this.appointOld.old_name
        ).length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.appointOld.old_name
            )[0].version
          : "",
      device_id: Number(this.overView.device),
      report_type: this.overView.type,

      scene_name: this.appointOld.scene,
      level: this.appointOld.level,
    });
    this.$nextTick(() => {
      this.renderFlameAppointRight(
        "#stackAppointStackRight",
        this.ObjectStackAppoinOldRightData
      );
      this.con_stack_loading = false;
    });
  }
  public async appoint_api_old() {
    dispatchObjectModuleListAppointOld(store, {
      project: this.localProject,
      start: "",
      end: "",
      device_id: this.overView.device,
      scene_name: this.appointOld.scene,
      level: this.appointOld.level,
      report_type: this.overView.type,
    });
    await dispatchObjectFunctionAppointOld(store, {
      project: this.localProject,
      report_type: this.overView.type,
      level: this.appointOld.level,
      start: "",
      end: "",
      scene_name: this.appointOld.scene,
      device_id: this.overView.device,
      date:
        this.dateVersion_option.filter((v) => v.name == this.appointOld.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.appointOld.name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter((v) => v.name == this.appointOld.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.appointOld.name
            )[0].version
          : "",
    });
    await dispatchObjectMemoryAppointOldLeftStack(store, {
      project: this.localProject,
      module: this.appointOld.moudel.join(";"),
      func: this.appointOld.func.join(";"),
      size: this.appointOld.size,
      date:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].version
          : "",
      device_id: Number(this.overView.device),
      report_type: this.overView.type,

      scene_name: this.appointOld.scene,
      level: this.appointOld.level,
    });
    this.$nextTick(() => {
      this.renderFlameAppointleft(
        "#stackAppointStackLeft",
        this.ObjectStackAppoinOldLeftData
      );
    });
    await dispatchObjectMemoryAppointOldRightStack(store, {
      project: this.localProject,
      module: this.appointOld.moudel,
      func: this.appointOld.func,
      size: this.appointOld.size,
      date:
        this.dateVersion_option.filter(
          (v) => v.name == this.appointOld.old_name
        ).length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.appointOld.old_name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter(
          (v) => v.name == this.appointOld.old_name
        ).length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.appointOld.old_name
            )[0].version
          : "",
      device_id: Number(this.overView.device),
      report_type: this.overView.type,

      scene_name: this.appointOld.scene,
      level: this.appointOld.level,
    });
    this.$nextTick(() => {
      this.renderFlameAppointRight(
        "#stackAppointStackRight",
        this.ObjectStackAppoinOldRightData
      );
      this.con_stack_loading = false;
    });
  }
  public;
  public expandCheck(data) {
    data.check = !data.check;
    console.log(data);
    if (!data.check) {
      let list = [];
      let addData = this.objectData[data.model].filter((v) => v.level != 0);
      console.log(addData);
      addData.forEach((v) => {
        list.push({
          model: data.model,
          data: v,
        });
      });
      let index = this.object_list_table.findIndex(
        (v) => v.model == data.model
      );
      if (index !== -1) {
        // 确保找到了索引
        this.object_list_table.splice(index + 1, 0, ...list);
      }
      console.log(this.object_list_table, index);
    } else {
      this.object_list_table = this.object_list_table.filter(
        (item) => !(item.model === data.model && item.data.level === 1)
      );
    }
  }
  public sub_stack_list = [];
  public async view(data) {
    this.activeName = "second";
    this.all_memory_loading = true;
    this.function_loading = true;
    this.sub_moudel_loading = true;
    this.sub_moudel_list_loading = true;
    this.function_table_loading = true;
    this.sub_moudel_list_loading = true;
    this.memory_report = true;
    this.sub_stack_list = [];
    await dispatchObjectMemoryType(store, {
      project: this.localProject,
    });
    this.overView.type = data.report_type;
    await dispatchObjectMemoryDateVersion(store, {
      project: this.localProject,
      report_type: this.overView.type,
    });
    this.overView.name = data.date + " " + data.cur_version;
    this.old_record_id_created();
    await dispatchObjectMemoryDeviceSecond(store, {
      project: this.localProject,
      report_type: this.overView.type,
      date:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].version
          : "",
    });
    this.overView.device = data.device.id;
    this.confirm_second();
    await dispatchObjectMemoryDateLevel(store, {
      project: this.localProject,
      report_type: this.overView.type,
      date:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].version
          : "",
      device_id: this.overView.device,
    });
    this.overView.level = data.level;
    this.sub_moudel.level = data.level;
    this.all_data.level = data.level;
    this.sub_moudel_trend.level = data.level;
    this.function_memory.level = data.level;
    this.appoint.level = data.level;
    this.appointOld.level = data.level;
    this.confirm_memoryAll();
    await dispatchObjectMemorySceneSecond(store, {
      project: this.localProject,
      report_type: this.overView.type,
      date:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].version
          : "",
      device_id: this.overView.device,
    });
    this.sub_moudel.scene = data.scene_name;
    this.all_data.scene = data.scene_name;
    this.sub_moudel_trend.scene = data.scene_name;
    this.function_memory.scene = data.scene_name;
    this.appoint.scene = data.scene_name;
    this.appointOld.scene = data.scene_name;
    this.function_api(true);
    this.sub_moudel_change();

    this.sub_moudel_api(true);

    this.alldata_change();
    this.appoint_api();
    this.appoint_api_old();

    this.second_check = false;
  }
  public sub_stack_loading = false;
  public appointChange() {
    dispatchObjectModuleListAppoint(store, {
      project: this.localProject,
      start: "",
      end: "",
      device_id: this.overView.device,
      scene_name: this.appoint.scene,
      level: this.appoint.level,
      report_type: this.overView.type,
    });
    dispatchObjectFunctionAppoint(store, {
      project: this.localProject,
      report_type: this.overView.type,
      level: this.appoint.level,
      start: "",
      end: "",
      scene_name: this.appoint.scene,
      device_id: this.overView.device,
      date:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].version
          : "",
    });
    this.appoint.func = [];
    this.appoint.moudel = [];
  }
  public appointOldChange() {
    dispatchObjectModuleListAppointOld(store, {
      project: this.localProject,
      start: "",
      end: "",
      device_id: this.overView.device,
      scene_name: this.appointOld.scene,
      level: this.appointOld.level,
      report_type: this.overView.type,
    });
    dispatchObjectFunctionAppointOld(store, {
      project: this.localProject,
      report_type: this.overView.type,
      level: this.appointOld.level,
      start: "",
      end: "",
      scene_name: this.appointOld.scene,
      device_id: this.overView.device,
      date:
        this.dateVersion_option.filter((v) => v.name == this.appointOld.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.appointOld.name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter((v) => v.name == this.appointOld.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.appointOld.name
            )[0].version
          : "",
    });
    this.appointOld.func = [];
    this.appointOld.moudel = [];
  }
  public arraysEqualIgnoreOrder(a, b) {
    if (a.length !== b.length) return false;
    const sortedA = [...a].sort();
    const sortedB = [...b].sort();

    for (let i = 0; i < sortedA.length; i++) {
      if (sortedA[i] !== sortedB[i]) return false;
    }

    return true;
  }
  public async sub_moudel_change() {
    this.sub_moudel_list_loading = true;
    this.sub_stack_loading = true;
    await dispatchObjectMemorymoduleAll(store, {
      project: this.localProject,
      report_type: this.overView.type,
      date:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].version
          : "",
      device_id: this.overView.device,
      scene_name: this.sub_moudel.scene,
      level: this.sub_moudel.level,
      top: this.sub_moudel.top,
      search: this.sub_moudel.serch,
      old_date:
        this.dateVersion_option.filter(
          (v) => v.name == this.sub_moudel.old_name
        ).length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.sub_moudel.old_name
            )[0].date
          : "",
      old_version:
        this.dateVersion_option.filter(
          (v) => v.name == this.sub_moudel.old_name
        ).length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.sub_moudel.old_name
            )[0].version
          : "",
      order_by: this.order_by_in,
      reverse: this.reserver_in,
    });
    this.sub_moudel_list_loading = false;
    this.sub_moudel.module = this.sub_moudel_data?.risk_module;
    this.sub_stack_list.push(this.sub_moudel.module);
    await dispatchObjectMemorySubStack(store, {
      project: this.localProject,
      id: this.sub_moudel_data?.id,
      module: this.sub_moudel.module.join(";"),
      func: "",
      size: "",
    });
    this.$nextTick(() => {
      this.renderFlameSub("#stackSub", this.ObjectStackSubData);
    });
    await dispatchObjectMemorySubStackOld(store, {
      project: this.localProject,
      id: this.sub_moudel_data?.old_id,
      module: this.sub_moudel.module.join(";"),
      func: "",
      size: "",
    });
    this.$nextTick(() => {
      this.renderFlameSubOld("#stackSubOld", this.ObjectStackSubDataOld);
    });
    this.sub_stack_loading = false;
  }
  public async subMemoryChange() {
    this.sub_stack_loading = true;
    await dispatchObjectMemorySubStack(store, {
      project: this.localProject,
      id: this.sub_moudel_data?.id,
      module: this.sub_moudel.module.join(";"),
      func: "",
      size: "",
    });
    this.$nextTick(() => {
      this.renderFlameSub("#stackSub", this.ObjectStackSubData);
    });
    await dispatchObjectMemorySubStackOld(store, {
      project: this.localProject,
      id: this.sub_moudel_data?.old_id,
      module: this.sub_moudel.module.join(";"),
      func: "",
      size: "",
    });
    this.$nextTick(() => {
      this.renderFlameSubOld("#stackSubOld", this.ObjectStackSubDataOld);
    });
    this.sub_stack_loading = false;
  }
  public stack = {
    size: "",
    module: [],
    func: [],
  };
  public async settingsBtn() {
    this.configShow = false;
    this.memory_report = true;
    let obj = this.settings;
    if (obj.object_memory_set) {
      if (obj.object_memory_set[this.device_id]) {
        obj.object_memory_set[this.device_id] = this.base_id
          ? this.dateVersion_device_option.filter(
              (v) => v.name == this.base_id
            )[0].date +
            " " +
            this.dateVersion_device_option.filter(
              (v) => v.name == this.base_id
            )[0].version
          : "";
      } else {
        obj.object_memory_set[this.device_id] = "";
        obj.object_memory_set[this.device_id] = this.base_id
          ? this.dateVersion_device_option.filter(
              (v) => v.name == this.base_id
            )[0].date +
            " " +
            this.dateVersion_device_option.filter(
              (v) => v.name == this.base_id
            )[0].version
          : "";
      }
    } else {
      obj.object_memory_set = {};
      if (this.device_id) {
        obj.object_memory_set[this.device_id] = this.base_id
          ? this.dateVersion_device_option.filter(
              (v) => v.name == this.base_id
            )[0].date +
            " " +
            this.dateVersion_device_option.filter(
              (v) => v.name == this.base_id
            )[0].version
          : "";
      }
    }
    // let obj: any = {
    //   perfetto_set: {
    //     name: this.base_id
    //       ? this.perfDateOptions.filter((v) => v.name == this.base_id)[0].date +
    //         " " +
    //         this.perfDateOptions.filter((v) => v.name == this.base_id)[0]
    //           .version
    //       : "",
    //   },
    // };

    obj = JSON.stringify(obj);

    await dispatchPerfettoSettingsEdit(store, {
      project: this.localProject,
      settings: obj,
    });
    this.confirm();
    // dispatchPerfettoReport(store, {
    //   project: this.localProject,
    //   date: this.date,
    //   version: this.version,
    //   device_id: this.device_id,
    //   report_type: Number(this.type_query),
    // });
    // dispatchPerfettoNativeModule(store, {
    //   project: this.localProject,
    //   level: this.level,
    //   device_id: Number(this.device_id),
    //   date: this.date,
    //   version: this.version,
    //   scene_id: this.scene_id,
    //   report_type: this.type_query,
    // });
    // this.report_loading = false;
    // this.moudle_loading = false;
  }
  public async settingsBtn_old() {
    this.configShow_old = false;
    this.memory_report = true;
    let obj = this.settings;
    if (obj.object_memory_set1) {
      if (obj.object_memory_set1.name) {
        obj.object_memory_set1.name = this.old_id
          ? this.dateVersion_option_new.filter((v) => v.name == this.old_id)[0]
              .date +
            " " +
            this.dateVersion_option_new.filter((v) => v.name == this.old_id)[0]
              .version
          : "";
      } else {
        obj.object_memory_set1.name = "";
        obj.object_memory_set1.name = this.old_id
          ? this.dateVersion_option_new.filter((v) => v.name == this.old_id)[0]
              .date +
            " " +
            this.dateVersion_option_new.filter((v) => v.name == this.old_id)[0]
              .version
          : "";
      }
    } else {
      obj.object_memory_set1 = {};
      obj.object_memory_set1.name = "";
      obj.object_memory_set1.name = this.old_id
        ? this.dateVersion_option_new.filter((v) => v.name == this.old_id)[0]
            .date +
          " " +
          this.dateVersion_option_new.filter((v) => v.name == this.old_id)[0]
            .version
        : "";
    }
    // let obj: any = {
    //   perfetto_set: {
    //     name: this.base_id
    //       ? this.perfDateOptions.filter((v) => v.name == this.base_id)[0].date +
    //         " " +
    //         this.perfDateOptions.filter((v) => v.name == this.base_id)[0]
    //           .version
    //       : "",
    //   },
    // };

    obj = JSON.stringify(obj);

    await dispatchPerfettoSettingsEdit(store, {
      project: this.localProject,
      settings: obj,
    });
    this.confirm_second();
    // dispatchPerfettoReport(store, {
    //   project: this.localProject,
    //   date: this.date,
    //   version: this.version,
    //   device_id: this.device_id,
    //   report_type: Number(this.type_query),
    // });
    // dispatchPerfettoNativeModule(store, {
    //   project: this.localProject,
    //   level: this.level,
    //   device_id: Number(this.device_id),
    //   date: this.date,
    //   version: this.version,
    //   scene_id: this.scene_id,
    //   report_type: this.type_query,
    // });
    // this.report_loading = false;
    // this.moudle_loading = false;
  }
  public sub_moudel_list_loading = false;
  public get level_options() {
    return readGetObjectMemoryLevel(store).options;
  }
  public risk_color(num) {
    let text = "";
    let color = "";
    if (typeof num == "number") {
      if (num < 0) {
        text = Math.abs(num) + "↓";
      } else {
        text = Math.abs(num) + "↑";
        if (num >= 10 && num <= 30) {
          color = "orange";
        } else if (num < 10) {
          color = "rgb(0, 176, 80)";
        } else if (num > 30) {
          color = "red";
        }
      }
    } else {
      text = num;
    }
    return [text, color];
  }
  public get perfReport_top() {
    let data = this.all_report.top_table;
    let list = [];
    data?.forEach((v) => {
      v.modules.forEach((m) => {
        list.push({
          level: v.level,
          scene: v.scene_name,
          version: v.cur_version + "vs" + v.last_version,
          diif_new: v.cur,
          memory_diff: v.diff,
          moudelName: m.name,
          diff: m.diff,
        });
      });
    });
    const sortedData = list.sort((a, b) => {
      if (a.level < b.level) {
        return -1;
      } else if (a.level > b.level) {
        return 1;
      } else {
        return 0;
      }
    });

    return sortedData;
  }
  public async functionChange(type) {
    this.function_loading = true;
    this.function_api(type);
  }
  public function_loading = false;
  public async confirm_second() {
    this.memory_report = true;
    await dispatchObjectMemoryReport(store, {
      project: this.localProject,
      report_type: this.overView.type,
      date: this.dateVersion_option.filter(
        (v) => v.name == this.overView.name
      )[0].date,
      version: this.dateVersion_option.filter(
        (v) => v.name == this.overView.name
      )[0].version,
      device_id: this.overView.device,
    });
    this.memory_report = false;
  }
  public memory_report = false;
  public activeName = "first";
  public async moudleChange() {
    await this.module_api();
    await this.objectTrend_api();
    for (let i in this.moudleTrendData) {
      this.drawModuleTrend(i);
    }
  }
  public get all_memory() {
    return readGetObjectMemoryReport(store).all_memory;
  }
  public get all_report() {
    return readGetObjectMemoryReport(store);
  }
  public get all_memoryData() {
    let list = [];
    for (let i in this.all_memory) {
      for (let k in this.all_memory[i]) {
        list.push({
          scene: i,
          level: k,
          data: this.all_memory[i][k],
        });
      }
    }
    return list;
  }
  public get dateVersion_option() {
    return readGetObjectDateVersion(store).date_list;
  }
  public get dateVersion_device_option() {
    return readGetObjectDateVersionDevice(store).date_list;
  }
  public get dateVersion_option_new() {
    return readGetObjectDateVersionNew(store).date_list;
  }
  public all_memory_loading = false;
  public overView = {
    type: "",
    name: "",
    device: "",
    level: "",
    pick: [],
  };
  public async changeDate(type, type1) {
    this.all_memory_loading = true;
    this.function_loading = true;
    this.sub_moudel_loading = true;
    this.sub_moudel_list_loading = true;
    this.function_table_loading = true;
    this.sub_moudel_list_loading = true;
    this.memory_report = true;
    if (type) {
      await dispatchObjectMemoryDateVersion(store, {
        project: this.localProject,
        report_type: this.overView.type,
      });
      this.overView.name = this.dateVersion_option[0].name;
      this.old_record_id_created();
    }
    if (type1) {
      await dispatchObjectMemoryDeviceSecond(store, {
        project: this.localProject,
        report_type: this.overView.type,
        date:
          this.dateVersion_option.filter((v) => v.name == this.overView.name)
            .length > 0
            ? this.dateVersion_option.filter(
                (v) => v.name == this.overView.name
              )[0].date
            : "",
        version:
          this.dateVersion_option.filter((v) => v.name == this.overView.name)
            .length > 0
            ? this.dateVersion_option.filter(
                (v) => v.name == this.overView.name
              )[0].version
            : "",
      });

      const option = this.device_options_second.find(item => item.name.includes('J200')) || this.device_options_second[0]
      this.overView.device = option?.device_id;
    }
    this.confirm_second();
    await dispatchObjectMemoryDateLevel(store, {
      project: this.localProject,
      report_type: this.overView.type,
      date:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].version
          : "",
      device_id: this.overView.device,
    });
    this.overView.level = this.level_options[0];
    this.sub_moudel.level = this.level_options[0];
    this.all_data.level = this.level_options[0];
    this.sub_moudel_trend.level = this.level_options[0];
    this.function_memory.level = this.level_options[0];
    this.appoint.level = this.level_options[0];
    this.appointOld.level = this.level_options[0];
    this.confirm_memoryAll();
    await dispatchObjectMemorySceneSecond(store, {
      project: this.localProject,
      report_type: this.overView.type,
      date:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].version
          : "",
      device_id: this.overView.device,
    });
    this.sub_moudel.scene = this.scene_second_options[0];
    this.all_data.scene = this.scene_second_options[0];
    this.sub_moudel_trend.scene = this.scene_second_options[0];
    this.function_memory.scene = this.scene_second_options[0];
    this.appoint.scene = this.scene_second_options[0];
    this.appointOld.scene = this.scene_second_options[0];
    this.sub_moudel_trend.scene = this.scene_second_options[0];
    this.function_memory.scene = this.scene_second_options[0];
    //    await dispatchObjectModuleListSecond(store,{
    //    project:this.localProject,
    //      start:'',
    //    end:'',
    //    device_id:this.overView.device,
    //    scene_name:this.sub_moudel_trend.scene
    // })

    this.function_api(true);
    this.sub_moudel_change();
    this.sub_moudel_api(type);
    this.alldata_change();
    this.appoint_api();
    this.appoint_api_old();
    //   await dispatchObjectModuleSubTrend(store,{
    //   project:this.localProject,
    //   start:'',
    //   end:'',
    //   device_id:this.overView.device,
    //   scene_name:this.sub_moudel_trend.scene,
    //   modules:this.sub_moudel_trend.moudel.join(','),
    //   report_type:this.overView.type

    // })
    //  this.drawModuleSubTrend()
    //  await dispatchObjectFuncAll(store, {
    //     project: this.localProject,
    //     level: this.all_data.level,
    //     device_id: Number(this.overView.device),
    //     date:this.dateVersion_option.filter(v=>v.name==this.overView.name).length>0?this.dateVersion_option.filter(v=>v.name==this.overView.name)[0].date:'',
    //   version:this.dateVersion_option.filter(v=>v.name==this.overView.name).length>0?this.dateVersion_option.filter(v=>v.name==this.overView.name)[0].version:'',
    //     scene_id: this.all_data.scene,
    //     top: this.all_data.top,
    //     search: this.all_data.serch,
    //      old_date:this.dateVersion_option.filter(v=>v.name==this.all_data.old_name).length>0?this.dateVersion_option.filter(v=>v.name==this.all_data.old_name)[0].date:'',
    //   old_version:this.dateVersion_option.filter(v=>v.name==this.all_data.old_name).length>0?this.dateVersion_option.filter(v=>v.name==this.all_data.old_name)[0].version:'',

    //     order_by: 'diff',
    //     reverse: this.reserver,
    //   });
  }
  public allmemoryChange() {
    this.all_memory_loading = true;
    this.confirm_memoryAll();
  }
  public get settings() {
    return JSON.parse(readGetPerfettoSettings(store).settings);
  }
  public stack_show = false;
  public second_check = true;
  public async handleClick() {
    if (this.second_check) {
      if (this.activeName == "second") {
        this.con_stack_loading = true;
        this.all_memory_loading = true;
        this.function_loading = true;
        this.sub_moudel_loading = true;
        this.sub_moudel_list_loading = true;
        this.function_table_loading = true;
        this.sub_moudel_list_loading = true;
        this.serch_stack_loading = true;
        this.memory_report = true;
        await dispatchObjectMemoryType(store, {
          project: this.localProject,
        });

        this.overView.type = this.object_type_options[0].report_type;
        await dispatchObjectMemoryDateVersion(store, {
          project: this.localProject,
          report_type: this.overView.type,
        });

        this.overView.name = this.dateVersion_option[0].name;

        this.old_record_id_created();
        await dispatchObjectMemoryDeviceSecond(store, {
          project: this.localProject,
          report_type: this.overView.type,
          date:
            this.dateVersion_option.filter((v) => v.name == this.overView.name)
              .length > 0
              ? this.dateVersion_option.filter(
                  (v) => v.name == this.overView.name
                )[0].date
              : "",
          version:
            this.dateVersion_option.filter((v) => v.name == this.overView.name)
              .length > 0
              ? this.dateVersion_option.filter(
                  (v) => v.name == this.overView.name
                )[0].version
              : "",
        });

        const option = this.device_options_second.find(item => item.name.includes('J200')) || this.device_options_second[0]
        this.overView.device = option?.device_id;
        this.confirm_second();
        //  await dispatchObjectMemoryReport(store,{
        //       project:this.localProject,
        //       report_type:this.overView.type,
        //       date:this.dateVersion_option.filter(v=>v.name==this.overView.name)[0].date,
        //       version:this.dateVersion_option.filter(v=>v.name==this.overView.name)[0].version,
        //       device_id:this.overView.device
        //     })
        await dispatchObjectMemoryDateLevel(store, {
          project: this.localProject,
          report_type: this.overView.type,
          date:
            this.dateVersion_option.filter((v) => v.name == this.overView.name)
              .length > 0
              ? this.dateVersion_option.filter(
                  (v) => v.name == this.overView.name
                )[0].date
              : "",
          version:
            this.dateVersion_option.filter((v) => v.name == this.overView.name)
              .length > 0
              ? this.dateVersion_option.filter(
                  (v) => v.name == this.overView.name
                )[0].version
              : "",
          device_id: this.overView.device,
        });
        this.overView.level = this.level_options[0];
        this.sub_moudel.level = this.level_options[0];
        this.all_data.level = this.level_options[0];
        this.sub_moudel_trend.level = this.level_options[0];
        this.function_memory.level = this.level_options[0];
        this.appoint.level = this.level_options[0];
        this.appointOld.level = this.level_options[0];
        this.confirm_memoryAll();
        await dispatchObjectMemorySceneSecond(store, {
          project: this.localProject,
          report_type: this.overView.type,
          date:
            this.dateVersion_option.filter((v) => v.name == this.overView.name)
              .length > 0
              ? this.dateVersion_option.filter(
                  (v) => v.name == this.overView.name
                )[0].date
              : "",
          version:
            this.dateVersion_option.filter((v) => v.name == this.overView.name)
              .length > 0
              ? this.dateVersion_option.filter(
                  (v) => v.name == this.overView.name
                )[0].version
              : "",
          device_id: this.overView.device,
        });
        this.sub_moudel.scene = this.scene_second_options[0];
        this.all_data.scene = this.scene_second_options[0];
        this.sub_moudel_trend.scene = this.scene_second_options[0];
        this.function_memory.scene = this.scene_second_options[0];
        this.appoint.scene = this.scene_second_options[0];
        this.appointOld.scene = this.scene_second_options[0];

        this.function_api(true);
        this.sub_moudel_change();

        this.sub_moudel_api(true);

        this.alldata_change();

        this.appoint_api();
        this.appoint_api_old();
      }
      this.second_check = false;
    }
  }
  public risk_color_text(text) {
    if (text == "中风险") {
      return "orange";
    } else if (text == "高风险") {
      return "red";
    } else if (text == "低风险") {
      return "#00b050";
    }
  }
  public async sort_change(column) {
    this.function_table_loading = true;

    this.reserver = column.order ? (column?.order == "ascending" ? 0 : 1) : "";
    this.order_by = column.prop
      ? column.prop == "risk"
        ? ""
        : column.prop
      : "";
    this.all_data.page = 1;
    await dispatchObjectFuncAll(store, {
      project: this.localProject,
      level: this.all_data.level,
      device_id: Number(this.overView.device),
      date:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].version
          : "",
      scene_name: this.all_data.scene,
      top: this.all_data.top,
      search: this.all_data.serch,
      old_date:
        this.dateVersion_option.filter((v) => v.name == this.all_data.old_name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.all_data.old_name
            )[0].date
          : "",
      old_version:
        this.dateVersion_option.filter((v) => v.name == this.all_data.old_name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.all_data.old_name
            )[0].version
          : "",

      order_by: this.order_by,
      reverse: this.reserver,
      report_type: this.overView.type,
    });
    this.function_table_loading = false;
  }
  public async sort_change_in(column) {
    this.sub_moudel_list_loading = true;
    this.reserver_in = column.order
      ? column?.order == "ascending"
        ? 0
        : 1
      : "";
    this.order_by_in = column.prop
      ? column.prop == "risk"
        ? ""
        : column.prop
      : "";
    this.sub_moudel.page = 1;
    await dispatchObjectMemorymoduleAll(store, {
      project: this.localProject,
      report_type: this.overView.type,
      date:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].version
          : "",
      device_id: this.overView.device,
      scene_name: this.sub_moudel.scene,
      level: this.sub_moudel.level,
      top: this.sub_moudel.top,
      search: this.sub_moudel.serch,
      old_date:
        this.dateVersion_option.filter(
          (v) => v.name == this.sub_moudel.old_name
        ).length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.sub_moudel.old_name
            )[0].date
          : "",
      old_version:
        this.dateVersion_option.filter(
          (v) => v.name == this.sub_moudel.old_name
        ).length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.sub_moudel.old_name
            )[0].version
          : "",
      order_by: this.order_by_in,
      reverse: this.reserver_in,
    });
    this.sub_moudel_list_loading = false;
  }
  public function_table_loading = false;
  public async alldata_change() {
    this.function_table_loading = true;
    await dispatchObjectFuncAll(store, {
      project: this.localProject,
      level: this.all_data.level,
      device_id: Number(this.overView.device),
      date:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].version
          : "",
      scene_name: this.all_data.scene,
      top: this.all_data.top,
      search: this.all_data.serch,
      old_date:
        this.dateVersion_option.filter((v) => v.name == this.all_data.old_name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.all_data.old_name
            )[0].date
          : "",
      old_version:
        this.dateVersion_option.filter((v) => v.name == this.all_data.old_name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.all_data.old_name
            )[0].version
          : "",

      order_by: this.order_by,
      reverse: this.reserver,
      report_type: this.overView.type,
    });
    this.function_table_loading = false;
    await dispatchObjectFunctionTrendAll(store, {
      project: this.localProject,
      report_type: this.overView.type,
      level: this.all_data.level,
      start: "",
      end: "",
      scene_name: this.all_data.scene,
      device_id: this.overView.device,
      date:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].date
          : "",
      version:
        this.dateVersion_option.filter((v) => v.name == this.overView.name)
          .length > 0
          ? this.dateVersion_option.filter(
              (v) => v.name == this.overView.name
            )[0].version
          : "",
    });

    // let data = readGetPerfettoFuncAll(store);
    // this.all_data.func = data.risk_func;
    // await dispatchObjectMemoryAllStack(store, {
    //   project: this.localProject,
    //   id: data.id,
    //   module: "",
    //   func: this.all_data.func.length > 0 ? this.all_data.func.join(";") : "",
    //   size: "",
    // });
    // this.renderFlameAll("#stackAllStack", this.ObjectStackAllData);
    // await dispatchObjectMemoryAllStackOld(store, {
    //   project: this.localProject,
    //   id: data.old_id,
    //   module: "",
    //   func: this.all_data.func.length > 0 ? this.all_data.func.join(";") : "",
    //   size: "",
    // });
    // this.renderFlameAll("#stackAllStackOld", this.ObjectStackAllDataOld);
  }
  public reserver: any = 1;
  public order_by: any = "";
  public reserver_in: any = 1;
  public order_by_in: any = "";

  public async sub_moudel_trend_change(type) {
    this.sub_moudel_loading = true;
    this.sub_moudel_api(type);
  }
  public async sub_moudel_api(type) {
    if (type) {
      await dispatchObjectModuleListSecond(store, {
        project: this.localProject,
        start: "",
        end: "",
        device_id: this.overView.device,
        scene_name: this.sub_moudel_trend.scene,
        level: this.sub_moudel_trend.level,
        report_type: this.overView.type,
      });
      this.sub_moudel_trend.moudel = this.moudle_list_second.filter(
        (v, index) => index <= 4
      );
    }

    await dispatchObjectModuleSubTrend(store, {
      project: this.localProject,
      start: "",
      end: "",
      device_id: this.overView.device,
      scene_name: this.sub_moudel_trend.scene,
      modules: this.sub_moudel_trend.moudel.join(","),
      report_type: this.overView.type,
      level: this.sub_moudel_trend.level,
    });
    this.drawModuleSubTrend();
    this.sub_moudel_loading = false;
  }
  public sub_moudel_loading = false;
  public get moudle_list() {
    return readGetObjectModuleList(store).options;
  }
  public get moudle_list_second() {
    return readGetObjectModuleListSecond(store).options;
  }
  public get moudleTrendData() {
    return readGetObjectModuleTrend(store);
  }
  public device_id = "";
  public drawModuleTrend(item) {
    let series: any[] = [];

    this.moudleTrendData[item].modules?.forEach((v, index) => {
      series.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: this.moudleTrendData[item]?.series[index],
        symbolSize: 8, // 调整数据点大小
        itemStyle: {
          normal: {
            lineStyle: {
              width: 4, // 设置线宽
            },

            // color: '#4ED8DA' //
          },
        },
      });
    });

    let performance_line: any = document.getElementById(item);

    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);

    contrastChart.setOption({
      backgroundColor: "#393E44", // 设置背景色
      tooltip: {
        trigger: "axis",
        confine: true,
        textStyle: {
          color: "#fff", // 文字颜色为白色
        },
        backgroundColor: "#2D3136", // 半透明黑色,
      },

      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        textStyle: {
          color: "#fff", // 设置legend文字颜色
        },
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        axisLabel: {
          textStyle: {
            color: "#fff", // 设置yAxis文字颜色
          },
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#606469",
          },
        },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.moudleTrendData[item].date_list,
        axisLabel: {
          textStyle: {
            color: "#fff", // 设置xAxis文字颜色
          },
        },
        axisLine: {
          lineStyle: {
            color: "#606469", // 修改 X 轴颜色
          },
        },
      },

      series: series,
    });
  }
  public drawModuleSubTrend() {
    let series: any[] = [];

    this.sub_moudel_trend_data.modules?.forEach((v, index) => {
      series.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: this.sub_moudel_trend_data?.series[index],
        symbolSize: 8, // 调整数据点大小
        itemStyle: {
          normal: {
            lineStyle: {
              width: 4, // 设置线宽
            },

            // color: '#4ED8DA' //
          },
        },
      });
    });

    let performance_line: any = document.getElementById("moudle_sub");

    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
        textStyle: {
          color: "#fff", // 文字颜色为白色
        },
        backgroundColor: "#2D3136", // 半透明黑色,
      },

      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        textStyle: {
          color: "#fff", // 设置legend文字颜色
        },
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        axisLabel: {
          textStyle: {
            color: "#fff", // 设置yAxis文字颜色
          },
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#606469",
          },
        },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.sub_moudel_trend_data.date_list,
        axisLabel: {
          textStyle: {
            color: "#fff", // 设置xAxis文字颜色
          },
        },
        axisLine: {
          lineStyle: {
            color: "#606469", // 修改 X 轴颜色
          },
        },
      },

      series: series,
    });
  }
  public drawFunctionTrend() {
    let series: any[] = [];

    this.function_trend_data.func_list?.forEach((v, index) => {
      series.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: this.function_trend_data?.series[index],
        symbolSize: 8, // 调整数据点大小
        itemStyle: {
          normal: {
            lineStyle: {
              width: 4, // 设置线宽
            },

            // color: '#4ED8DA' //
          },
        },
      });
    });

    let performance_line: any = document.getElementById("function_trend");
    console.log(this.moudleTrendData?.series);
    console.log(series);
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
        textStyle: {
          color: "#fff", // 文字颜色为白色
        },
        backgroundColor: "#2D3136", // 半透明黑色,
      },

      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        textStyle: {
          color: "#fff", // 设置legend文字颜色
        },
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        axisLabel: {
          textStyle: {
            color: "#fff", // 设置yAxis文字颜色
          },
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#606469",
          },
        },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.function_trend_data.date_list,
        axisLabel: {
          textStyle: {
            color: "#fff", // 设置xAxis文字颜色
          },
        },
        axisLine: {
          lineStyle: {
            color: "#606469", // 修改 X 轴颜色
          },
        },
      },

      series: series,
    });
  }
  public drawMemoryAllTrend() {
    let series: any[] = [];

    this.memory_all_data.scene_list?.forEach((v, index) => {
      series.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: this.memory_all_data?.series[index],
        symbolSize: 8, // 调整数据点大小
        itemStyle: {
          normal: {
            lineStyle: {
              width: 4, // 设置线宽
            },

            // color: '#4ED8DA' //
          },
        },
      });
    });

    let performance_line: any = document.getElementById("memory_all");

    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
        textStyle: {
          color: "#fff", // 文字颜色为白色
        },
        backgroundColor: "#2D3136", // 半透明黑色,
      },

      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        textStyle: {
          color: "#fff", // 设置legend文字颜色
        },
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        axisLabel: {
          textStyle: {
            color: "#fff", // 设置yAxis文字颜色
          },
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#606469",
          },
        },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.memory_all_data.date_list,
        axisLabel: {
          textStyle: {
            color: "#fff", // 设置xAxis文字颜色
          },
        },
        axisLine: {
          lineStyle: {
            color: "#606469", // 修改 X 轴颜色
          },
        },
      },

      series: series,
    });
  }
  public async objectTrend_api() {
    await dispatchObjectModuleTrend(store, {
      project: this.localProject,
      start: this.pick.length > 0 ? dateConversion(this.pick[0]) : "",
      end: this.pick.length > 0 ? dateConversion(this.pick[1]) : "",
      device_id: this.trend.device.join(","),
      scene_name: this.trend.scene.join(","),
      modules: this.trend.moudle.join(","),
    });
  }
  public async moudle_confirm() {
    this.test_data_trend_loading = true;
    await this.objectTrend_api();
    for (let i in this.moudleTrendData) {
      this.drawModuleTrend(i);
    }

    this.test_data_trend_loading = false;
  }
  public get_com_risk_color(num, type) {
    let color = "";
    let text = "";
    if (type == "Sum") {
      if (num > 10 && num <= 20) {
        color = "orange";
      } else if (num > 20) {
        color = "red";
      }
    } else {
      if (num > 5 && num <= 10) {
        color = "orange";
      } else if (num > 10) {
        color = "red";
      }
    }
    if (num < 0) {
      text = "↓" + Math.abs(num);
    } else if (num > 0) {
      text = "↑" + num;
    } else {
      text = num;
    }
    return [color, text];
  }
  public formatDate(date, fmt) {
    if (!date) {
      return "";
    }

    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (date?.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    }
    let o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + "";
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? str : this.padLeftZero(str)
        );
      }
    }

    return fmt;
  }
  public padLeftZero(str) {
    return ("00" + str).substr(str.length);
  }
  public async module_api() {
    await dispatchObjectModuleList(store, {
      project: this.localProject,
      start: this.pick.length > 0 ? dateConversion(this.pick[0]) : "",
      end: this.pick.length > 0 ? dateConversion(this.pick[1]) : "",
      device_id: this.trend.device.join(","),
      scene_name: this.trend.scene.join(","),
    });
    this.trend.moudle = this.moudle_list.filter((v, index) => index <= 9);
    return this.trend.moudle;
  }
  public async confirm() {
    // await this.options_api()
    this.test_data_loading = true;
    // await dispatchObjectMemoryList(store, {
    //   project: this.localProject,
    //   date: this.object_options_model.date.join(","),
    //   version: this.object_options_model.version.join(","),
    //   device_id: this.object_options_model.device.join(","),
    //   scene_name: this.object_options_model.scene.join(","),
    //      page:this.current_page,
    //   size:this.record
    // });
    // this.moudel_list_eight = this.moudel_list.filter((v, index) => index <= 7);
    await dispatchObjectMemoryListData(store, {
      project: this.localProject,
      date_list: this.object_options_model.date.join(","),
    });
    this.object_list_data();
    this.test_data_loading = false;
  }
  public test_data_loading = false;
  public test_data_trend_loading = false;
  
  public async mounted() {
    await this.options_api();
    //  this.object_options_model.date=this.optiosn_list?.date[0]
    //  this.object_options_model.version=this.optiosn_list?.version[0]
    //  this.object_options_model.device=this.optiosn_list?.device[0].device_id
    //  this.object_options_model.scene=this.optiosn_list?.scene[0]
    await dispatchPerfettoSettings(store, {
      project: this.localProject,
    });
    this.object_options_model.date = this.date_options.filter(
      (v, index) => index <= 9
    );
    // this.base_id = this.settings.object_memory_set
    //   ? this.settings.object_memory_set.name
    //   : "";
    // if(this.settings.object_memory_set){
    //   if(this.settings.object_memory_set[this.optiosn_list_label.device]){
    //     this.device_id=this.optiosn_list_label.device
    //     this.base_id=this.settings.object_memory_set[this.optiosn_list_label.device]?this.settings.object_memory_set[this.optiosn_list_label.device]:''
    //   }
    // }
    this.old_id = this.settings.object_memory_set1
      ? this.settings.object_memory_set1.name
      : "";
    this.test_data_loading = true;
    this.test_data_trend_loading = true;
    this.trend.device =
      this.device_options.filter((v) => v.name.indexOf("A33") != -1).length > 0
        ? [
            this.device_options.filter((v) => v.name.indexOf("A33") != -1)[0]
              .device_id,
          ]
        : [this.device_options[0].device_id];
    this.trend.scene =
      this.scene_options.filter((v) => v == "TotalBattle").length > 0
        ? [this.scene_options.filter((v) => v == "TotalBattle")[0]]
        : [];
    // const endDate = new Date();
    // const startDate = new Date();
    // startDate.setDate(startDate.getDate() - 7);
    // this.pick = [startDate, endDate];
    // this.overView.pick = [startDate, endDate];

    this.moudel_list_eight = this.moudel_list.filter((v, index) => index <= 7);
    await dispatchObjectMemoryListData(store, {
      project: this.localProject,
      date_list: this.object_options_model.date.join(","),
    });
    this.object_list_data();
    this.test_data_loading = false;
    await this.module_api();

    await this.objectTrend_api();
    for (let i in this.moudleTrendData) {
      this.drawModuleTrend(i);
    }
    this.test_data_trend_loading = false;
  }

  public moudel_list_eight = [];
  public moudel_Sum = ["Sum"];
  public get moudel_list() {
    return readGetObjectList(store).options;
  }
  public object_eight_filter = [];
  public object_list_table = [];
  public get objectData() {
    return readGetObjectListData(store);
  }
  public object_list_data() {
    let data = readGetObjectListData(store);
    this.object_list_table = [];
    for (let i in data) {
      let show = data[i].length > 1 ? true : false;
      data[i].forEach((v) => {
        if (v.level == 0) {
          this.object_list_table.push({
            model: i,
            data: v,
            check: true,
            show: show,
          });
        }
      });
    }
    console.log(this.object_list_table);
  }
  public get object_type_options() {
    return readGetObjectType(store).options;
  }
  public async options_api() {
    await dispatchObjectMemoryDate(store, {
      project: this.localProject,
    });
    await dispatchObjectMemoryList(store, {
      project: this.localProject,
    });
    await dispatchObjectMemoryVersion(store, {
      project: this.localProject,
    });
    await dispatchObjectMemoryDevice(store, {
      project: this.localProject,
    });
    await dispatchObjectMemoryScene(store, {
      project: this.localProject,
    });
    await dispatchObjectMemoryDateVersionNew(store, {
      project: this.localProject,
    });
  }
  public object_options_model = {
    date: [],
    // version: [],
    // device: [],
    // scene: [],
  };
  public async stackSubBtn(module, type) {
    this.sub_stack_loading = true;
    this.sub_moudel.module = [module];
    if (type == "new") {
      this.stack_width_sub = 100;
      this.stack_width_sub_old = 0;
      this.sub_old_show = false;
      if (
        !this.arraysEqualIgnoreOrder(
          this.sub_moudel.module[this.sub_moudel.module.length - 1],
          this.sub_moudel.module
        )
      ) {
        this.sub_stack_list.push(this.sub_moudel.module);
      }
      await dispatchObjectMemorySubStack(store, {
        project: this.localProject,
        id: this.sub_moudel_data?.id,
        module: this.sub_moudel.module.join(";"),
        func: "",
        size: "",
      });
      this.$nextTick(() => {
        this.renderFlameSub("#stackSub", this.ObjectStackSubData);
      });
    } else {
      this.stack_sub_title = type == "old" ? "基线版本" : "对比版本";
      this.sub_old_show = true;
      this.stack_width_sub = 47.5;
      this.stack_width_sub_old = 47.5;

      if (
        !this.arraysEqualIgnoreOrder(
          this.sub_stack_list[this.sub_stack_list.length - 1],
          this.sub_moudel.module
        )
      ) {
        console.log(3333);
        this.sub_stack_list.push(this.sub_moudel.module);
        await dispatchObjectMemorySubStack(store, {
          project: this.localProject,
          id: this.sub_moudel_data?.id,
          module: this.sub_moudel.module.join(";"),
          func: "",
          size: "",
        });
      }
      this.$nextTick(() => {
        this.renderFlameSub("#stackSub", this.ObjectStackSubData);
      });
      await dispatchObjectMemorySubStackOld(store, {
        project: this.localProject,
        id:
          type == "old"
            ? this.sub_moudel_data?.old_id
            : this.sub_moudel_data?.base_id,
        module: this.sub_moudel.module.join(";"),
        func: "",
        size: "",
      });
      this.$nextTick(() => {
        this.renderFlameSubOld("#stackSubOld", this.ObjectStackSubDataOld);
      });
    }
    this.sub_stack_loading = false;
  }
  public stack_loading = false;
  public stack_title = "";
  public stack_sub_title = "对比版本";
  public stack_width = 100;
  public stack_old_width = 0;
  public get date_options() {
    return readGetObjectDate(store).options;
  }
  public get scene_options() {
    return readGetObjectScene(store).options;
  }
  public get version_options() {
    return readGetObjectVersion(store).options;
  }
  public get device_options() {
    return readGetObjectDevice(store).device_list;
  }
  public get device_options_second() {
    return readGetObjectDeviceSecond(store).device_list;
  }
  public get optiosn_list() {
    return {
      date: this.date_options,
      // version: this.version_options,
      // scene: this.scene_options,
      // device: this.device_options,
    };
  }
  public optiosn_list_label = {
    date: "日期选择",
    // version: "版本",
    // scene: "场景",
    // device: "机型",
  };
}
